import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendEmailComponent } from './send-document.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ButtonModule, ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    ReactiveFormsModule,
    ButtonModule,
    ButtonsModule,
    DropDownsModule,
    InputsModule
  ],
  declarations: [SendEmailComponent],
  exports: [SendEmailComponent],
})
export class SendEmailModule { }
